// Per-case COVID-19 / Influenza up-to-date status (HCI-4786), served by
// POST immunization_api/vaccination-status. A client absent from the response
// (e.g. staff without ROLE_ADMIN_STAFF) renders blank; a failed request renders MISSING_VALUE.
import moment from "moment";

// outbreak.typeValue that enables vaccination status (tenant-configurable label,
// same literal the page already compares against for icons/colours).
export const RESPIRATORY_TYPE = "Respiratory";
export const MISSING_VALUE = "—";
export const VACCINATION_LOAD_ERROR = "There was an error loading vaccination status. Please reload the page to try again.";
const API_DATE_FORMAT = "YYYY-MM-DD";

export const VaccinationStatus = Object.freeze({
  UpToDate: "UP_TO_DATE",
  NotUpToDate: "NOT_UP_TO_DATE",
  Declined: "DECLINED",
  Unknown: "UNKNOWN"
});

const STATUS_LABELS = Object.freeze({
  [VaccinationStatus.UpToDate]: "Up to date",
  [VaccinationStatus.NotUpToDate]: "Not up to date",
  [VaccinationStatus.Declined]: "Declined",
  [VaccinationStatus.Unknown]: "Unknown"
});

export const VACCINATION_EXPORT_HEADERS = ["COVID-19 Status", "COVID-19 Date", "Influenza Status", "Influenza Date"];

export async function fetchVaccinationStatuses(http, clientIds, declaredDate) {
  const uniqueIds = [...new Set(clientIds)];
  if (uniqueIds.length === 0) return {};
  const asOfDate = moment.utc(declaredDate).format(API_DATE_FORMAT);
  const response = await http.post(`${window.CONFIG.immunization_api}/vaccination-status`, { clientIds: uniqueIds, asOfDate });
  if (response.body === null || typeof response.body !== "object") {
    throw new Error("vaccination-status returned a non-object body");
  }
  return response.body;
}

const formatEntry = (entry, dateFormat) => ({
  // A status this UI doesn't know yet reads as Unknown, not as blank (blank = not returned, e.g. staff).
  status: entry ? STATUS_LABELS[entry.status] || STATUS_LABELS[VaccinationStatus.Unknown] : "",
  date: entry && entry.date ? moment(entry.date, API_DATE_FORMAT).format(dateFormat) : ""
});

// statuses: response map, or null when the request failed.
export function vaccinationColumns(statuses, clientId, dateFormat) {
  if (statuses === null) {
    return {
      covidStatus: MISSING_VALUE,
      covidDate: MISSING_VALUE,
      influenzaStatus: MISSING_VALUE,
      influenzaDate: MISSING_VALUE
    };
  }
  const entry = statuses[clientId];
  const covid = formatEntry(entry && entry.covid, dateFormat);
  const influenza = formatEntry(entry && entry.influenza, dateFormat);
  return {
    covidStatus: covid.status,
    covidDate: covid.date,
    influenzaStatus: influenza.status,
    influenzaDate: influenza.date
  };
}

export const vaccinationExportValues = row => [row.covidStatus, row.covidDate, row.influenzaStatus, row.influenzaDate];
